/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteTempEvidencesRequest } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { TempEvidenceResponse } from '../model';
// @ts-ignore
import type { TempEvidenceResponseWithDuplicates } from '../model';
// @ts-ignore
import type { TempEvidenceSuggestionsStarted } from '../model';
// @ts-ignore
import type { UpdateTempEvidenceRequest } from '../model';
/**
 * TempEvidenceApi - axios parameter creator
 */
export const TempEvidenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload a file as temporary evidence.  This endpoint allows uploading evidence files that will be stored temporarily.  Args:     project_id: UUID of the project to associate the evidence with     file: The file to upload as evidence     name: Optional display name for the evidence; defaults to the file name  Returns:     TempEvidenceResponse: Details of the uploaded temporary evidence  Raises:     HTTPException 422: If file validation fails (missing info, unsupported type, too large)     HTTPException 500: If upload fails due to storage issues
         * @summary Create Temp Evidence
         * @param {string} projectId Project ID to associate the evidence with
         * @param {File} file Evidence file to upload (max 50 MB)
         * @param {string | null} [name] Optional display name for the evidence (defaults to the file name)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempEvidence: async (projectId: string, file: File, name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTempEvidence', 'projectId', projectId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createTempEvidence', 'file', file)
            const localVarPath = `/temp-evidence/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (projectId !== undefined) { 
                localVarFormParams.append('project_id', projectId as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a suggestion run over the ready candidates; the ones whose document is not ready are skipped.
         * @summary Create Temp Evidences Suggestions
         * @param {string} projectId Project ID to associate the evidence with
         * @param {boolean} [onlyNewUploads] Only run over uploads that were never attempted (used by the automatic post-upload trigger). By default the run covers every ready upload not already processing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempEvidencesSuggestions: async (projectId: string, onlyNewUploads?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTempEvidencesSuggestions', 'projectId', projectId)
            const localVarPath = `/temp-evidence/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (onlyNewUploads !== undefined) {
                localVarQueryParameter['only_new_uploads'] = onlyNewUploads;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to delete  Raises:     HTTPException 404: If temporary evidence is not found     HTTPException 403: If the user does not have permission to delete       the temporary evidence
         * @summary Delete Temp Evidence
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidence: async (tempEvidenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempEvidenceId' is not null or undefined
            assertParamExists('deleteTempEvidence', 'tempEvidenceId', tempEvidenceId)
            const localVarPath = `/temp-evidence/{temp_evidence_id}`
                .replace('{temp_evidence_id}', encodeURIComponent(String(tempEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Temp Evidence Control Suggestion
         * @param {string} controlId 
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidenceControlSuggestion: async (controlId: string, tempEvidenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('deleteTempEvidenceControlSuggestion', 'controlId', controlId)
            // verify required parameter 'tempEvidenceId' is not null or undefined
            assertParamExists('deleteTempEvidenceControlSuggestion', 'tempEvidenceId', tempEvidenceId)
            const localVarPath = `/temp-evidence/{temp_evidence_id}/suggestions/{control_id}`
                .replace('{control_id}', encodeURIComponent(String(controlId)))
                .replace('{temp_evidence_id}', encodeURIComponent(String(tempEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Temp Evidence Suggestions
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidenceSuggestions: async (tempEvidenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempEvidenceId' is not null or undefined
            assertParamExists('deleteTempEvidenceSuggestions', 'tempEvidenceId', tempEvidenceId)
            const localVarPath = `/temp-evidence/{temp_evidence_id}/suggestions`
                .replace('{temp_evidence_id}', encodeURIComponent(String(tempEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete temporary evidences by IDs.
         * @summary Delete Temp Evidences
         * @param {DeleteTempEvidencesRequest} deleteTempEvidencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidences: async (deleteTempEvidencesRequest: DeleteTempEvidencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteTempEvidencesRequest' is not null or undefined
            assertParamExists('deleteTempEvidences', 'deleteTempEvidencesRequest', deleteTempEvidencesRequest)
            const localVarPath = `/temp-evidence/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTempEvidencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Temp Evidences Suggestions
         * @param {string} projectId Project ID to associate the evidence with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidencesSuggestions: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteTempEvidencesSuggestions', 'projectId', projectId)
            const localVarPath = `/temp-evidence/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to retrieve  Returns:     TempEvidenceResponse: Details of the temporary evidence  Raises:     HTTPException 404: If temporary evidence is not found
         * @summary Get Temp Evidence
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempEvidence: async (tempEvidenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempEvidenceId' is not null or undefined
            assertParamExists('getTempEvidence', 'tempEvidenceId', tempEvidenceId)
            const localVarPath = `/temp-evidence/{temp_evidence_id}`
                .replace('{temp_evidence_id}', encodeURIComponent(String(tempEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get temporary evidences for current user and specific project. This endpoint also checks for duplicate files within the project and returns information about them.
         * @summary Get Temp Evidences
         * @param {string} projectId Project ID to associate the evidence with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempEvidences: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTempEvidences', 'projectId', projectId)
            const localVarPath = `/temp-evidence/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Temp Evidence
         * @param {string} tempEvidenceId 
         * @param {UpdateTempEvidenceRequest} updateTempEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempEvidence: async (tempEvidenceId: string, updateTempEvidenceRequest: UpdateTempEvidenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempEvidenceId' is not null or undefined
            assertParamExists('updateTempEvidence', 'tempEvidenceId', tempEvidenceId)
            // verify required parameter 'updateTempEvidenceRequest' is not null or undefined
            assertParamExists('updateTempEvidence', 'updateTempEvidenceRequest', updateTempEvidenceRequest)
            const localVarPath = `/temp-evidence/{temp_evidence_id}`
                .replace('{temp_evidence_id}', encodeURIComponent(String(tempEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTempEvidenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TempEvidenceApi - functional programming interface
 */
export const TempEvidenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TempEvidenceApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload a file as temporary evidence.  This endpoint allows uploading evidence files that will be stored temporarily.  Args:     project_id: UUID of the project to associate the evidence with     file: The file to upload as evidence     name: Optional display name for the evidence; defaults to the file name  Returns:     TempEvidenceResponse: Details of the uploaded temporary evidence  Raises:     HTTPException 422: If file validation fails (missing info, unsupported type, too large)     HTTPException 500: If upload fails due to storage issues
         * @summary Create Temp Evidence
         * @param {string} projectId Project ID to associate the evidence with
         * @param {File} file Evidence file to upload (max 50 MB)
         * @param {string | null} [name] Optional display name for the evidence (defaults to the file name)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTempEvidence(projectId: string, file: File, name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempEvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTempEvidence(projectId, file, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.createTempEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start a suggestion run over the ready candidates; the ones whose document is not ready are skipped.
         * @summary Create Temp Evidences Suggestions
         * @param {string} projectId Project ID to associate the evidence with
         * @param {boolean} [onlyNewUploads] Only run over uploads that were never attempted (used by the automatic post-upload trigger). By default the run covers every ready upload not already processing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTempEvidencesSuggestions(projectId: string, onlyNewUploads?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempEvidenceSuggestionsStarted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTempEvidencesSuggestions(projectId, onlyNewUploads, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.createTempEvidencesSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to delete  Raises:     HTTPException 404: If temporary evidence is not found     HTTPException 403: If the user does not have permission to delete       the temporary evidence
         * @summary Delete Temp Evidence
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTempEvidence(tempEvidenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTempEvidence(tempEvidenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.deleteTempEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Temp Evidence Control Suggestion
         * @param {string} controlId 
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTempEvidenceControlSuggestion(controlId: string, tempEvidenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTempEvidenceControlSuggestion(controlId, tempEvidenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.deleteTempEvidenceControlSuggestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Temp Evidence Suggestions
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTempEvidenceSuggestions(tempEvidenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTempEvidenceSuggestions(tempEvidenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.deleteTempEvidenceSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete temporary evidences by IDs.
         * @summary Delete Temp Evidences
         * @param {DeleteTempEvidencesRequest} deleteTempEvidencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTempEvidences(deleteTempEvidencesRequest: DeleteTempEvidencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTempEvidences(deleteTempEvidencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.deleteTempEvidences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Temp Evidences Suggestions
         * @param {string} projectId Project ID to associate the evidence with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTempEvidencesSuggestions(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTempEvidencesSuggestions(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.deleteTempEvidencesSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to retrieve  Returns:     TempEvidenceResponse: Details of the temporary evidence  Raises:     HTTPException 404: If temporary evidence is not found
         * @summary Get Temp Evidence
         * @param {string} tempEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTempEvidence(tempEvidenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempEvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTempEvidence(tempEvidenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.getTempEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get temporary evidences for current user and specific project. This endpoint also checks for duplicate files within the project and returns information about them.
         * @summary Get Temp Evidences
         * @param {string} projectId Project ID to associate the evidence with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTempEvidences(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TempEvidenceResponseWithDuplicates>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTempEvidences(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.getTempEvidences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Temp Evidence
         * @param {string} tempEvidenceId 
         * @param {UpdateTempEvidenceRequest} updateTempEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTempEvidence(tempEvidenceId: string, updateTempEvidenceRequest: UpdateTempEvidenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempEvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTempEvidence(tempEvidenceId, updateTempEvidenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TempEvidenceApi.updateTempEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TempEvidenceApi - factory interface
 */
export const TempEvidenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TempEvidenceApiFp(configuration)
    return {
        /**
         * Upload a file as temporary evidence.  This endpoint allows uploading evidence files that will be stored temporarily.  Args:     project_id: UUID of the project to associate the evidence with     file: The file to upload as evidence     name: Optional display name for the evidence; defaults to the file name  Returns:     TempEvidenceResponse: Details of the uploaded temporary evidence  Raises:     HTTPException 422: If file validation fails (missing info, unsupported type, too large)     HTTPException 500: If upload fails due to storage issues
         * @summary Create Temp Evidence
         * @param {TempEvidenceApiCreateTempEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempEvidence(requestParameters: TempEvidenceApiCreateTempEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<TempEvidenceResponse> {
            return localVarFp.createTempEvidence(requestParameters.projectId, requestParameters.file, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a suggestion run over the ready candidates; the ones whose document is not ready are skipped.
         * @summary Create Temp Evidences Suggestions
         * @param {TempEvidenceApiCreateTempEvidencesSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTempEvidencesSuggestions(requestParameters: TempEvidenceApiCreateTempEvidencesSuggestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TempEvidenceSuggestionsStarted> {
            return localVarFp.createTempEvidencesSuggestions(requestParameters.projectId, requestParameters.onlyNewUploads, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to delete  Raises:     HTTPException 404: If temporary evidence is not found     HTTPException 403: If the user does not have permission to delete       the temporary evidence
         * @summary Delete Temp Evidence
         * @param {TempEvidenceApiDeleteTempEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidence(requestParameters: TempEvidenceApiDeleteTempEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTempEvidence(requestParameters.tempEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Temp Evidence Control Suggestion
         * @param {TempEvidenceApiDeleteTempEvidenceControlSuggestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidenceControlSuggestion(requestParameters: TempEvidenceApiDeleteTempEvidenceControlSuggestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTempEvidenceControlSuggestion(requestParameters.controlId, requestParameters.tempEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Temp Evidence Suggestions
         * @param {TempEvidenceApiDeleteTempEvidenceSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidenceSuggestions(requestParameters: TempEvidenceApiDeleteTempEvidenceSuggestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTempEvidenceSuggestions(requestParameters.tempEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete temporary evidences by IDs.
         * @summary Delete Temp Evidences
         * @param {TempEvidenceApiDeleteTempEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidences(requestParameters: TempEvidenceApiDeleteTempEvidencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTempEvidences(requestParameters.deleteTempEvidencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Temp Evidences Suggestions
         * @param {TempEvidenceApiDeleteTempEvidencesSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTempEvidencesSuggestions(requestParameters: TempEvidenceApiDeleteTempEvidencesSuggestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTempEvidencesSuggestions(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to retrieve  Returns:     TempEvidenceResponse: Details of the temporary evidence  Raises:     HTTPException 404: If temporary evidence is not found
         * @summary Get Temp Evidence
         * @param {TempEvidenceApiGetTempEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempEvidence(requestParameters: TempEvidenceApiGetTempEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<TempEvidenceResponse> {
            return localVarFp.getTempEvidence(requestParameters.tempEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get temporary evidences for current user and specific project. This endpoint also checks for duplicate files within the project and returns information about them.
         * @summary Get Temp Evidences
         * @param {TempEvidenceApiGetTempEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempEvidences(requestParameters: TempEvidenceApiGetTempEvidencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TempEvidenceResponseWithDuplicates>> {
            return localVarFp.getTempEvidences(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Temp Evidence
         * @param {TempEvidenceApiUpdateTempEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTempEvidence(requestParameters: TempEvidenceApiUpdateTempEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<TempEvidenceResponse> {
            return localVarFp.updateTempEvidence(requestParameters.tempEvidenceId, requestParameters.updateTempEvidenceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTempEvidence operation in TempEvidenceApi.
 */
export interface TempEvidenceApiCreateTempEvidenceRequest {
    /**
     * Project ID to associate the evidence with
     */
    readonly projectId: string

    /**
     * Evidence file to upload (max 50 MB)
     */
    readonly file: File

    /**
     * Optional display name for the evidence (defaults to the file name)
     */
    readonly name?: string | null
}

/**
 * Request parameters for createTempEvidencesSuggestions operation in TempEvidenceApi.
 */
export interface TempEvidenceApiCreateTempEvidencesSuggestionsRequest {
    /**
     * Project ID to associate the evidence with
     */
    readonly projectId: string

    /**
     * Only run over uploads that were never attempted (used by the automatic post-upload trigger). By default the run covers every ready upload not already processing.
     */
    readonly onlyNewUploads?: boolean
}

/**
 * Request parameters for deleteTempEvidence operation in TempEvidenceApi.
 */
export interface TempEvidenceApiDeleteTempEvidenceRequest {
    readonly tempEvidenceId: string
}

/**
 * Request parameters for deleteTempEvidenceControlSuggestion operation in TempEvidenceApi.
 */
export interface TempEvidenceApiDeleteTempEvidenceControlSuggestionRequest {
    readonly controlId: string

    readonly tempEvidenceId: string
}

/**
 * Request parameters for deleteTempEvidenceSuggestions operation in TempEvidenceApi.
 */
export interface TempEvidenceApiDeleteTempEvidenceSuggestionsRequest {
    readonly tempEvidenceId: string
}

/**
 * Request parameters for deleteTempEvidences operation in TempEvidenceApi.
 */
export interface TempEvidenceApiDeleteTempEvidencesRequest {
    readonly deleteTempEvidencesRequest: DeleteTempEvidencesRequest
}

/**
 * Request parameters for deleteTempEvidencesSuggestions operation in TempEvidenceApi.
 */
export interface TempEvidenceApiDeleteTempEvidencesSuggestionsRequest {
    /**
     * Project ID to associate the evidence with
     */
    readonly projectId: string
}

/**
 * Request parameters for getTempEvidence operation in TempEvidenceApi.
 */
export interface TempEvidenceApiGetTempEvidenceRequest {
    readonly tempEvidenceId: string
}

/**
 * Request parameters for getTempEvidences operation in TempEvidenceApi.
 */
export interface TempEvidenceApiGetTempEvidencesRequest {
    /**
     * Project ID to associate the evidence with
     */
    readonly projectId: string
}

/**
 * Request parameters for updateTempEvidence operation in TempEvidenceApi.
 */
export interface TempEvidenceApiUpdateTempEvidenceRequest {
    readonly tempEvidenceId: string

    readonly updateTempEvidenceRequest: UpdateTempEvidenceRequest
}

/**
 * TempEvidenceApi - object-oriented interface
 */
export class TempEvidenceApi extends BaseAPI {
    /**
     * Upload a file as temporary evidence.  This endpoint allows uploading evidence files that will be stored temporarily.  Args:     project_id: UUID of the project to associate the evidence with     file: The file to upload as evidence     name: Optional display name for the evidence; defaults to the file name  Returns:     TempEvidenceResponse: Details of the uploaded temporary evidence  Raises:     HTTPException 422: If file validation fails (missing info, unsupported type, too large)     HTTPException 500: If upload fails due to storage issues
     * @summary Create Temp Evidence
     * @param {TempEvidenceApiCreateTempEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTempEvidence(requestParameters: TempEvidenceApiCreateTempEvidenceRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).createTempEvidence(requestParameters.projectId, requestParameters.file, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a suggestion run over the ready candidates; the ones whose document is not ready are skipped.
     * @summary Create Temp Evidences Suggestions
     * @param {TempEvidenceApiCreateTempEvidencesSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTempEvidencesSuggestions(requestParameters: TempEvidenceApiCreateTempEvidencesSuggestionsRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).createTempEvidencesSuggestions(requestParameters.projectId, requestParameters.onlyNewUploads, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to delete  Raises:     HTTPException 404: If temporary evidence is not found     HTTPException 403: If the user does not have permission to delete       the temporary evidence
     * @summary Delete Temp Evidence
     * @param {TempEvidenceApiDeleteTempEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTempEvidence(requestParameters: TempEvidenceApiDeleteTempEvidenceRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).deleteTempEvidence(requestParameters.tempEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Temp Evidence Control Suggestion
     * @param {TempEvidenceApiDeleteTempEvidenceControlSuggestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTempEvidenceControlSuggestion(requestParameters: TempEvidenceApiDeleteTempEvidenceControlSuggestionRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).deleteTempEvidenceControlSuggestion(requestParameters.controlId, requestParameters.tempEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Temp Evidence Suggestions
     * @param {TempEvidenceApiDeleteTempEvidenceSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTempEvidenceSuggestions(requestParameters: TempEvidenceApiDeleteTempEvidenceSuggestionsRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).deleteTempEvidenceSuggestions(requestParameters.tempEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete temporary evidences by IDs.
     * @summary Delete Temp Evidences
     * @param {TempEvidenceApiDeleteTempEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTempEvidences(requestParameters: TempEvidenceApiDeleteTempEvidencesRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).deleteTempEvidences(requestParameters.deleteTempEvidencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Temp Evidences Suggestions
     * @param {TempEvidenceApiDeleteTempEvidencesSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTempEvidencesSuggestions(requestParameters: TempEvidenceApiDeleteTempEvidencesSuggestionsRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).deleteTempEvidencesSuggestions(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get temporary evidence by ID.  Args:     temp_evidence_id: UUID of the temporary evidence to retrieve  Returns:     TempEvidenceResponse: Details of the temporary evidence  Raises:     HTTPException 404: If temporary evidence is not found
     * @summary Get Temp Evidence
     * @param {TempEvidenceApiGetTempEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTempEvidence(requestParameters: TempEvidenceApiGetTempEvidenceRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).getTempEvidence(requestParameters.tempEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get temporary evidences for current user and specific project. This endpoint also checks for duplicate files within the project and returns information about them.
     * @summary Get Temp Evidences
     * @param {TempEvidenceApiGetTempEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTempEvidences(requestParameters: TempEvidenceApiGetTempEvidencesRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).getTempEvidences(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Temp Evidence
     * @param {TempEvidenceApiUpdateTempEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTempEvidence(requestParameters: TempEvidenceApiUpdateTempEvidenceRequest, options?: RawAxiosRequestConfig) {
        return TempEvidenceApiFp(this.configuration).updateTempEvidence(requestParameters.tempEvidenceId, requestParameters.updateTempEvidenceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

